"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitView = exports.SPLIT_VIEW_COLUMN_GAP = void 0;
const pdfTheme_1 = require("../pdfTheme");
exports.SPLIT_VIEW_COLUMN_GAP = pdfTheme_1.pdfTheme.spacing.default;
class SplitView {
    constructor(leftColumn, rightColumn) {
        this.leftColumn = leftColumn;
        this.rightColumn = rightColumn;
        this.nodes = [];
        this.nodes = [...leftColumn, ...rightColumn];
    }
    exportContent() {
        return {
            columnGap: exports.SPLIT_VIEW_COLUMN_GAP,
            columns: [
                {
                    stack: this.leftColumn.map((node) => node.exportContent()),
                },
                {
                    stack: this.rightColumn.map((node) => node.exportContent()),
                },
            ],
        };
    }
}
exports.SplitView = SplitView;
//# sourceMappingURL=SplitView.js.map